import { toaster } from "@/shared/feedback/toaster";

type ToastType = "error" | "success" | "warning" | "info";

export interface ToastOptions {
  message: string;
  title?: string;
  type?: ToastType;
  duration?: number;
  closable?: boolean;
}

export const showToast = ({
  message,
  title,
  type = "info",
  duration = 2000,
  closable = true,
}: ToastOptions) => {
  toaster.create({
    description: message,
    title,
    duration,
    type,
    closable,
  });
};

export const showErrorToast = (message: string, duration?: number) =>
  showToast({ message, type: "error", duration });

export const showSuccessToast = (message: string, duration?: number) =>
  showToast({ message, type: "success", duration });

export const showWarningToast = (message: string, duration?: number) =>
  showToast({ message, type: "warning", duration });

export const showInfoToast = (message: string, duration?: number) =>
  showToast({ message, type: "info", duration });
